import { render, staticRenderFns } from "./orgpopup.vue?vue&type=template&id=5abbe183&scoped=true&"
import script from "./orgpopup.vue?vue&type=script&lang=js&"
export * from "./orgpopup.vue?vue&type=script&lang=js&"
import style0 from "./orgpopup.vue?vue&type=style&index=0&id=5abbe183&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abbe183",
  null
  
)

export default component.exports